module.exports = __webpack_public_path__ + "static/img/dishini.84a8a7b7.png";